<template>
  <component v-if="template" :is="template" :info />
</template>

<script setup>
import { getGoogleTemplatesInfo } from "@/api/google";
import { isInPWA, isInAndroidApp, isFacebookApp } from "@/env";
import { launchChrome } from "@/utils";

const info = ref(null);
const template = shallowRef(null);
const id = useRoute().query.tid;
const page = useRoute().query.pwaredirect;

const templates = {
  GoogleStore: defineAsyncComponent(() => import("./store.vue")),
  GoogleVideo: defineAsyncComponent(() => import("./video.vue")),
  StandardStore: defineAsyncComponent(() => import("./store.vue")),
  StandardVideo: defineAsyncComponent(() => import("./video.vue")),
};

onMounted(() => {
  if (page) return

  document.body.classList.add('googleTemplate');

  if (isFacebookApp) {
    launchChrome(location.href)
  }

  if (!isInPWA && !isInAndroidApp && !isFacebookApp) {
    showLoadingToast("loading...");
  }

  if (id && !isInPWA && !isInAndroidApp) {
    getGoogleTemplatesInfo({ id }).then(async ({ code, data }) => {
      closeToast();
      console.log("data", data);
      if (code === 1 && data) {
        info.value = data;
        template.value = templates[data.type] || null;
        // template.value = templates.GoogleVideo;

        if (!template.value) {
          showFailToast("Invalid template");
        }
      } else {
        showFailToast({
          message: 'error',
          duration: 0
        });
      }
    });
  } else {
    // if (!isInPWA && !isInAndroidApp) {
    //   showFailToast("Invalid tid");
    // }
  }
})
</script>

<style lang="scss">
body.googleTemplate {
  --van-popup-close-icon-margin: 12px;
  --van-popup-background: transparent;
  --van-image-placeholder-background: var(--theme-gray-gold20);
  --theme-red: #FF1241;
  --theme-gold: #FFAA0D;
  --theme-gold-dark: #161413;
  --theme-yellow: #FFAA0D;
  --theme-gray75: #FFFFFFBF;
  --theme-gray50: #FFFFFF80;
  --theme-gray10: #FFFFFF1A;

  --theme-primary: var(--theme-gold) !important;
  --theme-primary-dark: var(--theme-gold-dark);
  --theme-primary-hilight: var(--theme-red);
  --theme-primary-error: var(--theme-red);
  --theme-primary-gray: var(--theme-gray75);

  .btn {
    width: 100%;
    height: inherit;
    color: var(--btn-text-color);
    background-image: linear-gradient(90deg, #FD8541 0%, #EFBA6C 100%) !important;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    font-weight: inherit;
    border: none;
  }

  .primaryBtn {
    @extend .btn;

    width: 100%;
    height: 44px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.5px;

    .van-button__text {
      font-weight: 600;
    }
  }
}
</style>